import React from "react";
import { useSelector } from "react-redux";
import { RouteProps } from "react-router-dom";

import { StoreState } from "../store/types";
import { ProtectedRoute } from "./ProtectedRoute";

interface Props extends RouteProps {
  component: any;
  reverseLogic?: boolean;
}

export const AuthProtectedRoute: React.FC<Props> = ({
  component: Component,
  reverseLogic,
  ...rest
}) => {
  const auth = useSelector<StoreState, boolean>((state) => state.token !== "");

  let redirectRoute = "/authentication/login";
  let accessCondition = auth === true;
  if (reverseLogic) {
    accessCondition = !accessCondition;
    redirectRoute = "/offerings";
  }

  return (
    <ProtectedRoute
      component={Component}
      redirectRoute={redirectRoute}
      accessCondition={accessCondition}
      {...rest}
    />
  );
};
